<template>
  <div class="apply">
    <div class="box-card">
      <div class="head">
        <span class="applyTitle">特装申请</span>
        <span class="applyEnd">申请截止时间：2023年9月20日</span>
      </div>

      <div class="serveMessage">
        <!-- 展商信息 -->
        <div class="exhibitorsMsg">
          <p>展商信息</p>
          <div class="content">
            <div class="row">
              <div class="left">
                <span class="name">展商名称：</span
                ><span>{{ exhibitorsMsg.exhibitorsName }}</span>
              </div>
              <div class="right">
                <span class="name">公司地址：</span>
                <span>{{ exhibitorsMsg.companyName }}</span>
              </div>
            </div>

            <div class="row">
              <div class="left">
                <span class="name">展位号：</span
                ><span>{{ exhibitorsMsg.boothNumber }}</span>
              </div>
              <div class="right">
                <span class="name">展位类型：</span>
                <span>{{ exhibitorsMsg.boothType }}</span>
              </div>
            </div>

            <div class="row">
              <div class="left">
                <span class="name">展馆：</span>
                <span>{{ exhibitorsMsg.pavilion }}</span>
              </div>
              <div class="right">
                <span class="name">展位面积：</span>
                <span>{{ exhibitorsMsg.area }}</span>
              </div>
            </div>

            <div class="row">
              <div class="left">
                <span class="name">企业类型：</span>
                <span>{{ exhibitorsMsg.companyType }}</span>
              </div>
              <div class="right">
                <span class="name">联系人：</span>
                <span>{{ exhibitorsMsg.telPeople }}</span>
              </div>
            </div>

            <div class="row">
              <div class="left">
                <span class="name">手机：</span
                ><span>{{ exhibitorsMsg.telNumber }}</span>
              </div>
              <div class="right">
                <span class="name">电话：</span
                ><span>{{ exhibitorsMsg.phone }}</span>
              </div>
            </div>

            <div class="row">
              <div class="left">
                <span class="name">E-mail：</span
                ><span>{{ exhibitorsMsg.email }}</span>
              </div>
              <div class="right">
                <span class="name">展台类型：</span
                ><span class="my-el-select">
                  <el-select
                    v-model="exhibitorsMsg.type"
                    placeholder="请选择展台类型"
                    style="width: 260px"
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option> </el-select
                ></span>
              </div>
            </div>
          </div>
        </div>
        <!-- 搭建商信息 -->
        <div class="exhibitorsMsg">
          <p>搭建商信息</p>
          <div class="daJian">
            <el-form
              :model="numberValidateForm"
              label-width="107px"
              class="demo-ruleForm"
            >
              <el-row>
                <el-col :span="11">
                  <el-form-item
                    label="搭建商名称："
                    prop="name"
                    :rules="[{ required: true, message: '搭建商名称不能为空' }]"
                  >
                    <el-input
                      type="age"
                      v-model.number="numberValidateForm.name"
                      autocomplete="off"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item
                    label="搭建商地址："
                    prop="address"
                    :rules="[{ required: true, message: '搭建商地址不能为空' }]"
                  >
                    <el-input
                      type="age"
                      v-model.number="numberValidateForm.address"
                      autocomplete="off"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="11">
                  <el-form-item
                    label="联系人："
                    prop="telPeople"
                    :rules="[{ required: true, message: '联系人不能为空' }]"
                  >
                    <el-input
                      type="age"
                      v-model.number="numberValidateForm.telPeople"
                      autocomplete="off"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item
                    label="手机："
                    prop="tel"
                    :rules="[{ required: true, message: '手号码不能为空' }]"
                  >
                    <el-input
                      type="age"
                      v-model.number="numberValidateForm.tel"
                      autocomplete="off"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="11">
                  <el-form-item label="电话：" prop="phone">
                    <el-input
                      type="age"
                      v-model.number="numberValidateForm.phone"
                      autocomplete="off"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item
                    label="E-mail："
                    prop="email"
                    :rules="[{ required: true, message: 'E-mail不能为空' }]"
                    placeholder="请输入"
                  >
                    <el-input
                      type="age"
                      v-model.number="numberValidateForm.email"
                      autocomplete="off"
                      placeholder="请输入"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>

        <!--展台信息 -->
        <div class="exhibitorsMsg">
          <p>展台信息</p>
          <div class="daJian">
            <el-form
              :model="boothMag"
              label-width="123px"
              class="demo-ruleForm"
            >
              <el-row>
                <el-col :span="11">
                  <el-form-item
                    label="展台高度："
                    prop="boothHeight"
                    :rules="[{ required: true, message: '展台高度不能为空' }]"
                  >
                    <el-input
                      type="age"
                      v-model="boothMag.boothHeight"
                      autocomplete="off"
                      placeholder="请输入"
                      class="input"
                    ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <span class="layerNumber">展台层数：</span>
                  <span>
                    <el-radio v-model="boothMag.radio" label="1">一层</el-radio>
                    <el-radio v-model="boothMag.radio" label="2">二层</el-radio>
                  </span>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="11">
                  <el-form-item label="展台吊点：" prop="point">
                    <el-input
                      v-model.number="boothMag.point"
                      autocomplete="off"
                      placeholder="请输入"
                      class="point"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <!------------- 展台照明用电 ---------------------->
              <el-row>
                <el-col :span="11">
                  <el-form-item
                    label="展台照明用电："
                    prop="age"
                    :rules="[{ required: false, message: '123' }]"
                  >
                    <!-- 循环体头部标题 -->
                    <div class="lighting">
                      <div class="number">序号</div>
                      <div class="serveItem">服务项目</div>
                      <div>数量</div>
                    </div>
                    <!-- 循环体内容 -->
                    <div
                      class="lighting box"
                      v-for="(item, index) in booth"
                      :key="index"
                    >
                      <div class="number boxItem">{{ item.number }}</div>
                      <div class="serveItem boxItem">{{ item.serveItem }}</div>
                      <div class="count aa">
                        <el-input
                          v-model="item.num"
                          placeholder="输入数量"
                        ></el-input>
                      </div>
                      处
                    </div>

                    <!-- 展台用水 -->
                    <el-form-item
                      label="展台用水："
                      prop="age"
                      :rules="[{ required: false, message: '123' }]"
                      class="water"
                    >
                      <div class="lighting">
                        <div class="number">序号</div>
                        <div class="serveItem">服务项目</div>
                        <div>数量</div>
                      </div>
                      <div
                        class="lighting box"
                        v-for="(item, index) in water"
                        :key="index"
                      >
                        <div class="number boxItem">{{ item.number }}</div>
                        <div class="serveItem boxItem">
                          {{ item.serveItem }}
                        </div>
                        <div class="count aa">
                          <el-input
                            v-model="item.num"
                            placeholder="输入数量"
                          ></el-input>
                        </div>
                        处
                      </div>
                    </el-form-item>
                  </el-form-item>
                </el-col>

                <!------------- 展台动力用电 ---------------------->

                <el-col :span="11">
                  <el-form-item
                    label="展台动力用电："
                    prop="age"
                    :rules="[{ required: false, message: '123' }]"
                  >
                    <div class="lighting">
                      <div class="number">序号</div>
                      <div class="serveItem">服务项目</div>
                      <div>数量</div>
                    </div>
                    <div
                      class="lighting box"
                      v-for="(item, index) in boothPower"
                      :key="index"
                    >
                      <div class="number boxItem">{{ item.number }}</div>
                      <div class="serveItem boxItem">{{ item.serveItem }}</div>
                      <div class="count aa">
                        <el-input
                          v-model="item.num"
                          placeholder="输入数量"
                        ></el-input>
                      </div>
                      处
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-----------------上传展台效果图------------------->
              <el-row>
                <el-col :span="24">
                  <el-form-item
                    label="上传展台效果图："
                    :rules="[{ required: true }]"
                    style="margin-top: 17px"
                  >
                    <el-upload
                      drag
                      class="upload-demo"
                      action="#"
                      :on-preview="renderingPreview"
                      :on-remove="renderingRemove"
                      :on-success="renderingSuccess"
                      :on-error="renderingError"
                      :file-list="rendering"
                      list-type="picture"
                      v-if="flag"
                    >
                      <div class="el-upload__text">选择文件</div>
                    </el-upload>

                    <div class="imgBox" v-else>
                      <img
                        :src="i.imgUrl"
                        alt=""
                        v-for="(i, k) in renderingImgArr"
                        :key="k"
                      />
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- --------------上传展台平面图------------------->
              <el-row>
                <el-col :span="24">
                  <el-form-item
                    label="上传展台平面图："
                    :rules="[{ required: true }]"
                    style="margin-top: 17px"
                  >
                    <el-upload
                      drag
                      class="upload-demo"
                      action="#"
                      :on-preview="planPreview"
                      :on-remove="planRemove"
                      :on-success="planSuccess"
                      :on-error="planError"
                      :file-list="plan"
                      list-type="picture"
                      v-if="flag"
                    >
                      <div class="el-upload__text">选择文件</div>
                    </el-upload>

                    <div class="imgBox" v-else>
                      <img
                        :src="i.imgUrl"
                        alt=""
                        v-for="(i, k) in planImgArr"
                        :key="k"
                      />
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- --------------上传展台立面图------------------->
              <el-row>
                <el-col :span="24">
                  <el-form-item
                    label="上传展台立面图："
                    :rules="[{ required: true }]"
                    style="margin-top: 17px"
                  >
                    <el-upload
                      drag
                      class="upload-demo"
                      action="#"
                      :on-preview="elevationPreview"
                      :on-remove="elevationRemove"
                      :on-success="elevationSuccess"
                      :on-error="elevationError"
                      :file-list="elevation"
                      list-type="picture"
                      v-if="flag"
                    >
                      <div class="el-upload__text">选择文件</div>
                    </el-upload>

                    <div class="imgBox" v-else>
                      <img
                        :src="i.imgUrl"
                        alt=""
                        v-for="(i, k) in elevationImgArr"
                        :key="k"
                      />
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- ------------------------------------------- -->
            </el-form>

            <div class="btn">
              <div class="why" v-show="!flag">
                审核未通过,请重新填写信息后再提交<el-tooltip
                  class="item"
                  effect="dark"
                  content="信息部分缺失,请查看信息"
                  placement="top-start"
                >
                  <router-link to="#">未通过原因</router-link>
                </el-tooltip>
              </div>
              <el-button type="primary" v-if="flag">提交</el-button>
              <el-button type="primary" v-else>审核中</el-button>
            </div>
          </div>
        </div>
        <!-- 展商信息 -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //展商信息
      exhibitorsMsg: {
        exhibitorsName: "中国煤炭工业国际技术咨询有限责任公司",
        companyName: "黄寺大街一号",
        boothNumber: "W000001",
        boothType: "12m标准展位",
        pavilion: "W1馆",
        area: "12m",
        companyType: "国内展商",
        telPeople: "张三",
        telNumber: "18529461836",
        phone: "010-83651839",
        email: "123@qq.com",
        type: "岛型开口",
      },
      //展商信息中展台类型的下拉列表
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      //搭建商数组信息
      numberValidateForm: {
        name: "",
        address: "",
        telPeople: "",
        tel: "",
        phone: "",
        email: "",
      },

      //展台信息内容
      boothMag: {
        boothHeight: "",
        radio: "1",
        point: "",
      },

      //展台照明用电
      booth: [
        {
          number: "1",
          serveItem: "15A/220V",
          num: 1,
        },
        {
          number: "2",
          serveItem: "20A/220V",
          num: 2,
        },
        {
          number: "3",
          serveItem: "30A/220V",
          num: "",
        },
        {
          number: "4",
          serveItem: "40A/220V",
          num: "",
        },
        {
          number: "5",
          serveItem: "50A/220V",
          num: "",
        },
        {
          number: "6",
          serveItem: "60A/220V",
          num: "",
        },
        {
          number: "7",
          serveItem: "80A/220V",
          num: "",
        },
        {
          number: "8",
          serveItem: "100A/220V",
          num: "",
        },
        {
          number: "9",
          serveItem: "120A/220V",
          num: "",
        },
      ],
      //展台动力用电
      boothPower: [
        {
          number: "1",
          serveItem: "施工临时用电15A/220V",
          num: "",
        },
        {
          number: "2",
          serveItem: "施工临时用电30A/220V",
          num: "",
        },
        {
          number: "3",
          serveItem: "15A/220V/24hr（单相）",
          num: "",
        },
        {
          number: "4",
          serveItem: "30A/220V/24hr（三相）",
          num: "",
        },
        {
          number: "5",
          serveItem: "15A/220V（单相）",
          num: "",
        },
        {
          number: "6",
          serveItem: "30A/380V（三相）",
          num: "",
        },
        {
          number: "7",
          serveItem: "60A/380V（三相）",
          num: "",
        },
        {
          number: "8",
          serveItem: "100A/380V（三相）",
          num: "",
        },
        {
          number: "9",
          serveItem: "150A/380V（单相）",
          num: "",
        },
        {
          number: "10",
          serveItem: "200A/380V（三相）",
          num: "",
        },
        {
          number: "11",
          serveItem: "300A/380V（三相）",
          num: "",
        },
        {
          number: "12",
          serveItem: "400A/380V（三相）",
          num: "",
        },
      ],
      //展台用水
      water: [
        {
          number: "1",
          serveItem: "15A/220V",
          num: "",
        },
        {
          number: "2",
          serveItem: "15A/220V",
          num: "",
        },
        {
          number: "3",
          serveItem: "15A/220V",
          num: "",
        },
        {
          number: "4",
          serveItem: "15A/220V",
          num: "",
        },
      ],
      //展台效果图
      rendering: [{ name: "#", url: "#" }],
	  //展台效果图图片上传到此数组
	  renderingImgArr: [
        { imgUrl: require("../../../../static/indexBanner.png") },
        { imgUrl: require("../../../../static/indexBanner.png") },
        { imgUrl: require("../../../../static/indexBanner.png") },
      ],
      //展台平面图
      plan: [{ name: "#", url: "#" }],
	  //展台平面图图片上传到此数组
      planImgArr: [
        { imgUrl: require("../../../../static/indexBanner.png") },
        { imgUrl: require("../../../../static/indexBanner.png") },
        { imgUrl: require("../../../../static/indexBanner.png") },
     ], 
      //展台立面图
      elevation: [{ name: "#", url: "#" }],
      //展台立面图图片上传到此数组
	 elevationImgArr: [
        { imgUrl: require("../../../../static/indexBanner.png") },
        { imgUrl: require("../../../../static/indexBanner.png") },
        { imgUrl: require("../../../../static/indexBanner.png") },
      ],
      flag: true, //审核信息标志位
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    //-----------展台效果图的相关钩子----------------
    //点击文件列表中已上传的文件时的钩子
    renderingRemove(file, fileList) {
      console.log(file, fileList);
    },
    //文件列表移除文件时的钩子
    renderingPreview(file) {
      console.log(file);
    },
    //文件上传成功时的钩子
    renderingSuccess(file) {
      console.log(file);
    },
    //文件上传失败时的钩子
    renderingError(file) {
      console.log(file);
    },

    //-----------展台平面图的相关钩子----------------
    //点击文件列表中已上传的文件时的钩子
    planRemove(file, fileList) {
      console.log(file, fileList);
    },
    //文件列表移除文件时的钩子
    planPreview(file) {
      console.log(file);
    },
    //文件上传成功时的钩子
    planSuccess(file) {
      console.log(file);
    },
    //文件上传失败时的钩子
    planError(file) {
      console.log(file);
    },

    //-----------展台立面图的相关钩子----------------
    //点击文件列表中已上传的文件时的钩子
    elevationRemove(file, fileList) {
      console.log(file, fileList);
    },
    //文件列表移除文件时的钩子
    elevationPreview(file) {
      console.log(file);
    },
    //文件上传成功时的钩子
    elevationSuccess(file) {
      console.log(file);
    },
    //文件上传失败时的钩子
    elevationError(file) {
      console.log(file);
    },
  },
};
</script>

<style scoped lang="scss">
.apply {
  padding: 17px 26px;
  box-sizing: border-box;
  background: #f0f2f5;
  .box-card {
    width: 100%;
    border-radius: 2px;
    background: #ffffff;
    .head {
      padding: 17px 0px;
      border-bottom: 1px solid #e8e8e8;
      .applyTitle {
        font-size: 17px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 24px;
        margin-left: 26px;
      }
      .applyEnd {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 17px;
        margin-left: 17px;
      }
    }
    .serveMessage {
      margin: 0px 26px;
      padding-top: 35px;
      .exhibitorsMsg {
        p {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
          padding-bottom: 9px;
          border-bottom: 1px solid #e9e9e9;
        }
        .content {
          // padding: 26px 130px 0px 130px;
          margin: 26px 130px 0px 130px;
          .row {
            display: flex;
            padding-bottom: 26px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            .left {
              width: 512px;
              display: flex;
              align-items: center;
              .name {
                width: 61px;
                text-align: right;
              }
            }
            .right {
              display: flex;
              flex: 1;
              align-items: center;
              .name {
                display: block;
                width: 61px;
                text-align: right;
              }
            }
          }
        }
        //搭建商
        .daJian {
          margin: 25px 138px 0px 86px;
          position: relative;

          .imgBox {
            width: 295%;
            position: relative;
            top: 11px;
            left: 0px;
            img {
              width: 225px;
              height: 170px;
              background-color: skyblue;
              margin-right: 17px;
            }
          }

          .layerNumber {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            .el-radio__label {
              font-size: 12px;
              padding-left: 7px;
            }
          }
          .lighting {
            width: 381px;
            height: 36px;
            background: #006fb8;
            border-radius: 3px 3px 0px 0px;
            display: flex;
            align-items: center;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(255, 255, 255, 0.85);
            .number {
              width: 65px;
              text-align: center;
            }
            .serveItem {
              width: 205px;
            }
            .count {
              width: 109px;
            }
          }
          .box {
            width: 381px;
            height: 36px;
            background-color: rgb(255, 255, 255);
            padding: 15px 0px;
            color: black;
            border-bottom: 1px solid #e8e8e8;
          }
          .water {
            position: relative;
            left: -123px;
            top: 20px;
          }
          .input {
            &::after {
              content: "m";
              margin-left: 10px;
            }
          }
          .point {
            &::after {
              content: "个";
              margin-left: 10px;
            }
          }
          .btn {
            margin-top: 20px;
            padding-bottom: 30px;
            .why {
              margin-left: 120px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #ff190c;
              a {
                margin-left: 10px;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #006fb8;
              }
            }
          }
        }
      }
    }
  }
}
</style>

<style scoped>
/* 下拉框样式修改 */
.el-select >>> .el-input__inner {
  height: 28px !important;
}
.el-select >>> .el-input__icon {
  line-height: 28px !important;
}
.row >>> .el-input__inner {
  width: 260px !important;
  height: 28px !important;
}
/* 搭建商信息 */
.el-form-item >>> .el-input__inner {
  width: 260px;
  height: 28px;
}
.el-form-item >>> .el-form-item__label {
  padding: 0px;
}
.el-form-item >>> .el-form-item__error {
  top: 85% !important;
}
.count >>> .el-input__inner {
  width: 100px;
  height: 28px;
}

.count >>> .el-input {
  width: 100px;
  height: 28px;
}

.upload-demo >>> .el-upload-dragger {
  width: 225px;
  height: 173px;
  background: #f1f1f1;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0px;
}

.upload-demo >>> .el-upload__text {
  width: fit-content;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  width: 93px;
  height: 28px;
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  line-height: 27px;
}
.el-button--primary {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  width: 76px;
  height: 28px;
  line-height: 0px;
  background-color: #006fb8;
  text-align: center;
}
.upload-demo >>> .el-upload-list__item {
  width: 225px;
  height: 173px;
  border-radius: 0px;
}
</style>
